import Tooltip from "./tooltip"
import "./index.scss"
import "./information.scss"
import "./hint.scss"

export default function setListeners(container = document) {
  Array.from(container.querySelectorAll(".tooltip")).forEach((el) => {
    const type = el.classList.contains("tooltip--info") ? "info" : "hint"
    const tooltip = new Tooltip(el, type)
    tooltip.init()
  })
}
